import { FaWhatsapp } from "react-icons/fa";
const message = encodeURIComponent("Hellow JT Group");
const ConsultationSection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "Request a Private Consultation",
      desc:
        "Prefer to talk directly? Reach us on WhatsApp for a faster, more personal response.",
      btn: "Request a Private Consultation",
      msg: "Hello, I would like to request a private consultation with JT Group.",
    },

    zh: {
      title: "预约私人咨询",
      desc:
        "想直接沟通？通过 WhatsApp 联系我们，获得更快速、更个性化的回复。",
      btn: "预约私人咨询",
      msg: "你好，我想预约 JT Group 的私人咨询。",
    },
  };

  const message = encodeURIComponent(text[lang].msg);

  return (
    <section className="bg-[#EBEBEB] py-10 mb-10">

      <div className="max-w-[1200px] mx-auto px-6 text-center">

        <h2 className="text-[34px] font-medium text-[#154059] leading-snug">
          {text[lang].title}
        </h2>

        <p className="text-gray-600 mt-5 leading-relaxed text-[15px] mb-6">
          {text[lang].desc}
        </p>

     <a
  href={`https://wa.me/6596861698?text=${message}`}
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white px-8 py-3 rounded-full font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
>
  <FaWhatsapp size={20} />
  {text[lang].btn}
</a>

      </div>

    </section>
  );
};

export default ConsultationSection;